import Icon from '../components/Icon.vue'

Icon.register({
  subscript: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h16v-96h-16c-8.8 0-16-7.2-16-16 0-2.1 0.8-5.3 1.7-7.2l16-32c2.4-4.9 8.8-8.8 14.3-8.8h48c8.8 0 16 7.2 16 16v144h16zM336 64c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16h-33.5l-77.8 112 77.8 112h33.5c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16h-67c-4.6 0-10.4-3.1-13.1-6.9l-79.9-115-79.9 115c-2.6 3.8-8.5 6.9-13.1 6.9h0-67c-8.8 0-16-7.2-16-16v-48c0-8.8 7.2-16 16-16h33.5l77.8-112-77.8-112h-33.5c-8.8 0-16-7.2-16-16v-48c0-8.8 7.2-16 16-16h67c4.6 0 10.4 3.1 13.1 6.9l79.9 115 79.9-115c2.6-3.8 8.5-6.9 13.1-6.9h0 67z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/subscript.js
// module id = 1961
// module chunks = 0